import { render, staticRenderFns } from "./ResumeEducation.vue?vue&type=template&id=edb24e16&scoped=true"
import script from "./ResumeEducation.vue?vue&type=script&lang=js"
export * from "./ResumeEducation.vue?vue&type=script&lang=js"
import style0 from "./ResumeEducation.vue?vue&type=style&index=0&id=edb24e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb24e16",
  null
  
)

export default component.exports